export default __webpack_public_path__ + "static/media/Ability_Telekinesis.f42efe19.png";